import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {DialogService} from '@rbaip/ui-component';
import {Address, Contact, AddressFormComponent } from "@rbaip/address-form";
import {AssetLocationService} from "../../shared/asset-package/asset-location.service";
import {SellerLocation} from "../../shared/domain/item";

@Component({
  selector: 'lib-item-summary-storage-location-details',
  templateUrl: './storage-location.component.html',
  styleUrls: ['./storage-location.component.scss']
})
export class StorageLocationComponent implements OnInit {

  @ViewChild('addressEditor') addressForm : AddressFormComponent;

  assetLocation:SellerLocation;
  forkLift:boolean;
  loadingDock:boolean;
  ramp:boolean;
  willSellerLoad:boolean;
  public address: Address;
  private contact: Contact;
  enableEditAltInsp : boolean =false;
  enableEditInsp:boolean= false;
  enableEditPickup=false;
  oneLineFullAddress:string;
  addLocationFlag: boolean = false;
  addContactInfoFlag: boolean = false;
  addressDto : Address;
  selectedIndex: number = 0;
  enableAddressForm: boolean = false;
  enableSaveLocationOnModelSave: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any,
              private dialogRef: MatDialogRef<StorageLocationComponent>,
              private dialogService: DialogService,
              private assetLocationService: AssetLocationService) {
    this.assetLocation = Object.assign(new SellerLocation(), this.data.location);
    if (this.data.addLocationFlag) {
      this.addLocationFlag = this.data.addLocationFlag;
    }
    if (!!this.data.enableSaveLocationOnModelSave) {
      this.enableSaveLocationOnModelSave = this.data.enableSaveLocationOnModelSave;
    }
    if (this.data.addContactInfoFlag) {
      this.addContactInfoFlag = this.data.addContactInfoFlag;
      this.enableAddressForm = true;
      this.selectedIndex = 1;
    }
    this.oneLineFullAddress= '';
    if(this.assetLocation.addressDto) {
      this.addressDto = Object.assign(new Address(), this.assetLocation.addressDto);
      this.oneLineFullAddress = this.assetLocation.addressDto.oneLineFullAddress;
    }
    this.initializeEmptyContact();
    this.forkLift= this.assetLocation.forklift && this.assetLocation.forklift == 'Y';
    this.loadingDock = this.assetLocation.loadingDock && this.assetLocation.loadingDock == 'Y';
    this.ramp= this.assetLocation.ramp && this.assetLocation.ramp == 'Y';
    this.willSellerLoad= this.assetLocation.willSellerLoad && this.assetLocation.willSellerLoad == 'Y';
    dialogRef.disableClose= true;
  }

  ngOnInit() {
    this.contact = new Contact();
    this.initializeEmptyContact();
  }

  initializeEmptyContact(){
    if(this.assetLocation)
    {
      if(this.assetLocation.transportContact == null || this.assetLocation.transportContact == undefined){
        this.assetLocation.transportContact = new Contact();
      }
      if(this.assetLocation.inspContact == null || this.assetLocation.inspContact == undefined ){
        this.assetLocation.inspContact = new Contact();
      }
      if(this.assetLocation.altInspContact == null || this.assetLocation.altInspContact == undefined){
        this.assetLocation.altInspContact = new Contact();
      }
    }
  }

  saveLocationDetails(){
    if ( !this.assetLocation.locationDesc ) {
      this.dialogService.showMessage('Location Name is Required ', 5000);
      return;
    }
    if (this.addressForm && this.addressForm.isEditingAddress && !this.addressForm.isValidAddress()) {
      this.dialogService.showMessage('Please enter valid Address ', 5000);
      return;
    }
    this.prepareLocationDetails();
    if(this.addContactInfoFlag && !this.enableSaveLocationOnModelSave){
      setTimeout(() => {
        this.dialogRef.close(this.assetLocation);
      }, 500);
    }
    else {
      this.dialogService.showProgress();
      this.assetLocationService.saveLocation(this.assetLocation).subscribe((updatedLocation) => {
        if (this.addLocationFlag) {
          this.dialogService.showMessage('Successfully added new Location details');
        } else {
          this.dialogService.showMessage('Successfully updated Location details');
        }
        this.assetLocation = updatedLocation;
        this.initializeEmptyContact();
        this.dialogService.hideProgress();
        this.dialogRef.close(this.assetLocation);
      }, error => {
        this.dialogService.hideProgress();
        if (this.addLocationFlag) {
          this.dialogService.showMessage('ERROR in adding new Location details');
        } else {
          this.dialogService.showMessage('ERROR in updated Location details');
        }
      })
    }
  }

  prepareLocationDetails(){
    this.assetLocation.forklift = this.forkLift ? 'Y' :  null;
    this.assetLocation.loadingDock = this.loadingDock ? 'Y' : null;
    this.assetLocation.ramp = this.ramp ? 'Y' : null;
    this.assetLocation.willSellerLoad = this.willSellerLoad ? 'Y' : null;
    if(this.assetLocation.inspContact != null){ // Dont want to create empty contact
      if(!this.assetLocation.inspContact.firstName  && !this.assetLocation.inspContact.lastName &&  !this.assetLocation.inspContact.cellPhoneNumber
       && !this.assetLocation.inspContact.faxNumber && !this.assetLocation.inspContact.voicePhoneNumber && !this.assetLocation.inspContact.email){
        this.assetLocation.inspContact = null;
      }
    }

    if(this.assetLocation.altInspContact != null){ // Dont want to create empty contact
      if(!this.assetLocation.altInspContact.firstName && !this.assetLocation.altInspContact.lastName &&  !this.assetLocation.altInspContact.cellPhoneNumber
        && !this.assetLocation.altInspContact.faxNumber && !this.assetLocation.altInspContact.voicePhoneNumber && !this.assetLocation.altInspContact.email){
        this.assetLocation.altInspContact = null;
      }
    }

    if(this.assetLocation.transportContact != null){ // Dont want to create empty contact
      if(!this.assetLocation.transportContact.firstName && !this.assetLocation.transportContact.lastName &&  !this.assetLocation.transportContact.cellPhoneNumber
        && !this.assetLocation.transportContact.faxNumber && !this.assetLocation.transportContact.voicePhoneNumber && !this.assetLocation.transportContact.email){
        this.assetLocation.transportContact = null;
      }
    }

  }

  public consumeAddressChanged(updatedAddress: Address): void {
    this.contact.updateAddressBasedOnGooglePlacesAddress(updatedAddress);
    this.address = updatedAddress;
    this.assetLocation.addressDto = this.address;
  }

  enableEditingAltInsp(){
    this.enableEditAltInsp = !this.enableEditAltInsp;
  }

  enableEditingInsp(){
    this.enableEditInsp =! this.enableEditInsp;
  }

  enableEditingPickup(){
    this.enableEditPickup = !this.enableEditPickup;
  }

  clearInspectionScheduling() {
    this.assetLocation.inspContact = new Contact();
  }

  clearAltInsp() {
    this.assetLocation.altInspContact = new Contact();
  }

  clearPickupCoOrdination() {
    this.assetLocation.transportContact = new Contact();
  }

  isAddOrEditContact(contactInfo): boolean {
    for (let key in contactInfo){
      return contactInfo[key] ? true : false;
    }
  }

}
